<h2 mat-dialog-title i18n>{{ data.title }}</h2>
<mat-dialog-content>
  <form class="form-container" [formGroup]="sampleDetailsForm">
    <app-input [formCntlName]="sampleName" [inputType]="textInputType" [placeholder]="data.namePlaceholder">
    </app-input>
    <mat-error class="error" i18n *ngIf="sampleName.hasError('required') && sampleName.touched"
      >Please enter Sample Name.</mat-error
    >
    <mat-error class="error" i18n *ngIf="sampleName.hasError('maxlength')">
      Sample name cannot be longer than 256 characters
    </mat-error>
    <mat-error class="error" i18n *ngIf="sampleName.hasError('whitespace') && sampleName.touched"
      >Input cannot be just spaces.
    </mat-error>
    <app-input
      [formCntlName]="sampleDescription"
      [inputType]="textInputType"
      [placeholder]="data.descriptionPlaceholder"
    >
    </app-input>
    <mat-error class="error" i18n *ngIf="sampleDescription.hasError('maxlength')">
      Description cannot be longer than 1024 characters
    </mat-error>
    <mat-error class="error" i18n *ngIf="sampleDescription.hasError('whitespace') && sampleName.touched"
      >Input cannot be just spaces.
    </mat-error>
  </form>
  <mat-error *ngIf="isErrorVisible" i18n>{{ errorMessage }}</mat-error>
</mat-dialog-content>
<mat-dialog-actions>
  <app-buttons
    *ngIf="data.showSecondaryButton"
    [isDisabled]="false"
    [name]="data.secondaryButtonLabel"
    [buttonType]="btnMat"
    [buttonStyle]="btnStyleText"
    (buttonClickEvent)="onSecondaryAction()"
    [arialLabel]="arialLabelCancel"
  >
  </app-buttons>

  <app-buttons
    *ngIf="data.showPrimaryButton"
    [isDisabled]="!sampleDetailsForm.valid || isErrorVisible"
    [name]="data.primaryButtonLabel"
    [buttonType]="btnMatFlat"
    [buttonStyle]="
      sampleDetailsForm.valid && !isErrorVisible
        ? btnStyleFilledSmallForPrimaryBtn
        : btnStyleFilledSmallForPrimaryBtnDisabled
    "
    (buttonClickEvent)="onPrimaryAction()"
    [arialLabel]="arialLabelCreateSample"
  >
  </app-buttons>
</mat-dialog-actions>
